import { cn } from "@/lib/utils";

type TabPanelProps = {
  active: boolean;
  children: React.ReactNode;
};

const TabPanel = ({ active, children }: TabPanelProps) => (
  <div
    aria-hidden={!active}
    className={cn(
      active
        ? "relative opacity-100"
        : "pointer-events-none absolute inset-0 opacity-0",
      "transition-opacity duration-150",
    )}
  >
    {children}
  </div>
);

export default TabPanel;
